import styled from '@emotion/styled';
import { Button } from 'src/domains/layouts/webview/components/common/button/Button';
import { Messages } from 'src/domains/layouts/webview/components/Messages/Messages';

export const LoginBtnWrapper = styled(Button, { label: 'LoginBtnWrapper' })`
    display: block;
    margin: 16px 0 8px 0;
    width: 100%;
`;

export const LoginMessages = styled(Messages, { label: 'LoginMessages' })`
    margin-bottom: 16px;
`;
